import axiosClient from './axiosClient';

export const vendorDashboardService = {
    // Fetch all dashboard data
    getDashboard: async (params) => {
        const { data } = await axiosClient.get(`/vendor/dashboard`, { params });
        return data.data;
    },

    // Toggle store status
    toggleStatus: async (isAvailable) => {
        const { data } = await axiosClient.patch(`/vendor/dashboard/toggle-status`, { isAvailable });
        return data.data;
    }
};

export const dashboardService = {
    vendorDashboardSummary: async () => {
        const response = await axiosClient.get('/vendor/dashboard/summary');
        return response.data.data;
    },
    vendorSalesAnalytics: async (params) => {
        const response = await axiosClient.get('/vendor/dashboard/sales', { params });
        return response.data.data;
    },
    vendorOrderAnalytics: async (params) => {
        const response = await axiosClient.get('/vendor/dashboard/orders/status', { params });
        return response.data.data;
    },
    vendorTopSellingProducts: async (params) => {
        const response = await axiosClient.get('/vendor/dashboard/top-selling-products', { params });
        return response.data.data;
    },
    vendorLowStockProducts: async () => {
        const response = await axiosClient.get('/vendor/dashboard/products/low-stock');
        return response.data.data;
    },
    vendorAvailabilityStatus: async () => {
        const response = await axiosClient.get('/vendor/dashboard/store/status');
        return response.data.data;
    },
    updateVendorAvailabilityStatus: async (available) => {
        const response = await axiosClient.patch('/vendor/dashboard/store/status', { available: available });
        return response.data.data;
    },
    vendorRecentOrders: async (params) => {
        const response = await axiosClient.get('/vendor/dashboard/orders/recent', { params });
        return response.data.data;
    },
    vendorCustomersReviews: async (params) => {
        const response = await axiosClient.get('/vendor/dashboard/reviews/customers', { params });
        return response.data.data;
    },
    getSalesReport: async () => {
        const response = await axiosClient.get('/dashboard/vendor/sales');
        return response.data.data;
    }
};
